import type { IconName } from '../shared/ui/Icon';
export interface NavigationItem { path: string; label: string; icon: IconName; group: string }
export const hotelNavigation: NavigationItem[] = [
    { path: '/overview', label: 'Overview', icon: 'home', group: '' },
    { path: '/property', label: 'Property', icon: 'building', group: 'Operations' },
    { path: '/inventory', label: 'Inventory & Rates', icon: 'calendar', group: 'Operations' },
    { path: '/reservations', label: 'Reservations', icon: 'reservations', group: 'Operations' },
    { path: '/partners', label: 'Partners & Contracts', icon: 'partners', group: 'Commercial' },
    { path: '/distribution', label: 'Distribution', icon: 'link', group: 'Commercial' },
    { path: '/reports', label: 'Reports', icon: 'chart', group: 'Insights' },
];
export const buyerNavigation: NavigationItem[] = [
    { path: '/search', label: 'Find a stay', icon: 'search', group: '' },
    { path: '/reservations', label: 'My bookings', icon: 'reservations', group: 'Buyer workspace' },
    { path: '/partners', label: 'My agreements', icon: 'partners', group: 'Buyer workspace' },
    { path: '/property', label: 'Available hotels', icon: 'building', group: 'Buyer workspace' },
];
export const settingsNavigation: NavigationItem = { path: '/settings', label: 'Settings', icon: 'settings', group: '' };
